import { UseFormSetValue } from 'react-hook-form'
import { UserData } from '../_props'

export const validateRequiredStringValue = (val: string) => val?.trim().length > 0

export const isEmailValid = (val: any) => {
    if (!val || val.length === 0) {
        return 'Email incorrect'
    }
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]{2,3}$/
    return re.test(val) ? undefined : 'Email incorrect'
}

// used when SMS mode is chosen for sending password
export const missingPrivatePhoneErrorMessage =
    'Le numéro personnel est obligatoire lorsque le mode d’envoi du mot de passe choisi est par SMS. Veuillez compléter ce champ ou changer de mode d’envoi'

export const updateEmailTooltipTitle = `Cliquez sur le bouton "modifier" pour être redirigé vers l'interface de changement de courriel`

export const updatePrivatePhoneTooltipTitle = `Cliquez sur le bouton "modifier" pour être redirigé vers l'interface de changement de numéro de téléphone`

export const resetUserFieldTooltipTitle =
    "Champ uniquement modifiable par l'utilisateur du compte. Si nécessaire, vous pouvez réinitialiser cette information, l'utilisateur pourra la renseigner par la suite"

export const getTooltipTitle = (selfMode: boolean, isEditionMode: boolean, fieldName: string) => {
    if (selfMode) {
        return fieldName === 'phone' ? updatePrivatePhoneTooltipTitle : updateEmailTooltipTitle
    }
    if (isEditionMode && fieldName === 'phone') {
        return resetUserFieldTooltipTitle
    }
    return undefined
}

export const HIDDEN_VALUE = '***************'
export const HIDDEN_PHONE_VALUE = '** ** ** ** **'

export const professionsFieldsToReset: (keyof UserData)[] = ['professionPointer', 'professionId', 'profession']
export const specialitiesFieldsToReset: (keyof UserData)[] = ['specialityPointer', 'speciality', 'specialityId']

export const resetRelatedFields = (fields: (keyof UserData)[], setValue: UseFormSetValue<UserData>) => {
    fields.forEach((field) => {
        setValue(field, '', { shouldValidate: false })
    })
}
